export default __webpack_public_path__ + "static/media/hype.1d18d2ad.png";